import API from '../app.api';

export const getMyActivity = async () => {
    const res = await API.get('/api/v1/common/me/activity');
    return res.data;
};
